import { render, staticRenderFns } from "./ApplicationCard.vue?vue&type=template&id=283dd20c&scoped=true"
import script from "./ApplicationCard.vue?vue&type=script&lang=js"
export * from "./ApplicationCard.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCard.vue?vue&type=style&index=0&id=283dd20c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283dd20c",
  null
  
)

export default component.exports